<template>
    <div>
        <div class="reponse-menu">
            <a href="#GoMainMenu">메인 메뉴 바로가기</a>
            <a href="#GoContent">본문 바로가기</a>
            <a href="#GoGMenu">글로벌 메뉴 바로가기</a>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ResponseMenu',
};
</script>
